export const FollowUpRecipientsEnum = Object.freeze({
  AdminNotification: 1,
  LeadCommunication: 2
});
